// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__3_ySZ","colBig":"styles_colBig__3y1Vc","colSmall":"styles_colSmall__2sZsD"};